module.exports = __webpack_public_path__ + "img/bg.87a389be.png";